<template>
  <svg
    v-if="icon === 'leftArrow'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    :class="iconClass"
  >
    <path
      d="M5.46198 5.29308L0.874985 9.87908C0.31428 10.4426 -0.000488281 11.2052 -0.000488281 12.0001C-0.000488281 12.795 0.31428 13.5576 0.874985 14.1211L5.46098 18.7071C5.55323 18.8026 5.66358 18.8788 5.78558 18.9312C5.90758 18.9836 6.0388 19.0112 6.17158 19.0123C6.30436 19.0135 6.43604 18.9882 6.55894 18.9379C6.68184 18.8876 6.79349 18.8134 6.88738 18.7195C6.98127 18.6256 7.05553 18.5139 7.10581 18.391C7.15609 18.2681 7.18139 18.1365 7.18024 18.0037C7.17908 17.8709 7.1515 17.7397 7.09909 17.6177C7.04668 17.4957 6.97049 17.3853 6.87498 17.2931L2.58398 13.0001H23C23.2652 13.0001 23.5196 12.8947 23.7071 12.7072C23.8946 12.5197 24 12.2653 24 12.0001C24 11.7349 23.8946 11.4805 23.7071 11.293C23.5196 11.1054 23.2652 11.0001 23 11.0001H2.58298L6.87598 6.70708C6.97149 6.61483 7.04768 6.50449 7.10009 6.38249C7.1525 6.26048 7.18008 6.12926 7.18124 5.99648C7.18239 5.8637 7.15709 5.73202 7.10681 5.60913C7.05653 5.48623 6.98227 5.37458 6.88838 5.28069C6.79449 5.18679 6.68284 5.11254 6.55994 5.06226C6.43704 5.01198 6.30536 4.98668 6.17258 4.98783C6.0398 4.98898 5.90858 5.01657 5.78658 5.06898C5.66458 5.12139 5.55423 5.19757 5.46198 5.29308Z"
    />
  </svg>

  <svg
    v-else-if="icon === 'megaphone'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    :class="iconClass"
  >
    <path
      d="M23 16C22.8452 16 22.6925 15.964 22.554 15.895L20.554 14.895C20.3166 14.7764 20.1361 14.5685 20.0521 14.3168C19.968 14.0651 19.9874 13.7904 20.106 13.553C20.2246 13.3156 20.4325 13.1351 20.6842 13.0511C20.9359 12.967 21.2106 12.9864 21.448 13.105L23.448 14.105C23.6499 14.2056 23.8118 14.3715 23.9075 14.5757C24.0032 14.78 24.027 15.0106 23.9751 15.2301C23.9232 15.4496 23.7987 15.6451 23.6216 15.7848C23.4446 15.9246 23.2255 16.0004 23 16ZM21.447 6.9L23.447 5.9C23.6844 5.78145 23.8649 5.57346 23.9489 5.32178C24.033 5.07011 24.0136 4.79537 23.895 4.558C23.7764 4.32063 23.5685 4.14008 23.3168 4.05606C23.0651 3.97205 22.7904 3.99145 22.553 4.11L20.553 5.11C20.3156 5.22855 20.1351 5.43654 20.0511 5.68822C19.967 5.93989 19.9864 6.21463 20.105 6.452C20.2236 6.68937 20.4315 6.86992 20.6832 6.95394C20.9349 7.03795 21.2096 7.01855 21.447 6.9V6.9ZM24 10C24 9.73478 23.8946 9.48043 23.7071 9.29289C23.5196 9.10536 23.2652 9 23 9H21C20.7348 9 20.4804 9.10536 20.2929 9.29289C20.1054 9.48043 20 9.73478 20 10C20 10.2652 20.1054 10.5196 20.2929 10.7071C20.4804 10.8946 20.7348 11 21 11H23C23.2652 11 23.5196 10.8946 23.7071 10.7071C23.8946 10.5196 24 10.2652 24 10ZM18 19V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0C16.7348 0 16.4804 0.105357 16.2929 0.292893C16.1054 0.48043 16 0.734784 16 1C16 3.949 13.417 5 11 5H4C2.93913 5 1.92172 5.42143 1.17157 6.17157C0.421427 6.92172 0 7.93913 0 9L0 11C0 12.0609 0.421427 13.0783 1.17157 13.8284C1.92172 14.5786 2.93913 15 4 15H11C13.417 15 16 16.051 16 19C16 19.2652 16.1054 19.5196 16.2929 19.7071C16.4804 19.8946 16.7348 20 17 20C17.2652 20 17.5196 19.8946 17.7071 19.7071C17.8946 19.5196 18 19.2652 18 19ZM8.186 17H4C3.53441 16.9981 3.07063 16.9421 2.618 16.833L5.118 22.415C5.32796 22.8868 5.67018 23.2876 6.10324 23.5689C6.53629 23.8502 7.0416 24 7.558 24C7.96885 23.9995 8.37304 23.8961 8.73371 23.6993C9.09439 23.5026 9.4001 23.2187 9.62297 22.8736C9.84585 22.5284 9.97881 22.133 10.0097 21.7233C10.0406 21.3136 9.96855 20.9027 9.8 20.528L8.186 17Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true },
    size: { type: String, default: "5.5rem" },
    iconClass: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.main-action {
  fill: colors.$distantStar;
}

.secondary-action {
  fill: colors.$grayThree;
}

.action-disabled {
  fill: colors.$grayFour;
}
</style>
